module.exports = __webpack_public_path__ + "img/boredom.cfdc40f1.svg";